<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Grupa statusa: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <osoba-razdoblje-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                >
                </osoba-razdoblje-forma>
            </div>
        </div>
    </div>
</template>

<script>
import OsobeNavigation from "../OsobeNavigation";
import OsobaRazdobljeForma from "./OsobaRazdobljeForma";
export default {
    name: "OsobaRazdobljeEdit",
    components: { OsobaRazdobljeForma, OsobeNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.osoba_razdoblje_id,
            osoba_id: this.$route.params.osoba_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblja',
                    name: 'Razdoblja'
                },
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblja/' + this.id,
                    name: 'Razdoblje: ' + this.naziv
                },
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblja/' + this.id + '/edit',
                    name: 'Uredi razdoblje: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.datum_od + ' - ' + data.datum_od
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
